import { render } from "./DowntimesHostsAdd.vue?vue&type=template&id=7d64bab7"
import script from "./DowntimesHostsAdd.vue?vue&type=script&lang=js"
export * from "./DowntimesHostsAdd.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__